"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconContainer = _interopRequireDefault(require("../IconContainer"));

var _typography = require("../typography");

var _Icons = require("../Icons");

var _Card = require("../Card");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "FlexCard",
  componentId: "sc-1ix8dak-0"
})(["display:inline-flex;flex-direction:row;"]);

var AlertContentSection = _styledComponents.default.div.withConfig({
  displayName: "AlertContentSection",
  componentId: "sc-1ix8dak-1"
})(["display:flex;flex-direction:column;align-items:flex-start;flex:1 1 auto;"]);

var DismissalContainer = (0, _styledComponents.default)(_IconContainer.default).withConfig({
  displayName: "DismissalContainer",
  componentId: "sc-1ix8dak-2"
})(["display:block;height:16px;width:16px;cursor:pointer;margin-left:1em;font-size:0.5rem;"]);

var Alert = function Alert(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onDismiss = _ref.onDismiss,
      testId = _ref.testId,
      title = _ref.title,
      type = _ref.type,
      elevation = _ref.elevation;
  return _react.default.createElement(FlexCard, {
    className: className,
    cardStyle: type,
    "data-test-id": testId,
    elevation: elevation
  }, _react.default.createElement(_Icon.Icon, {
    type: type
  }), _react.default.createElement(AlertContentSection, null, title && _react.default.createElement(_typography.Strong, null, title), children), onDismiss && _react.default.createElement(DismissalContainer, {
    onClick: function onClick() {
      return onDismiss();
    }
  }, _react.default.createElement(_Icons.CancelIcon, null)));
};

var _default = (0, _styledComponents.default)(Alert).withConfig({
  componentId: "sc-1ix8dak-3"
})([""]);

exports.default = _default;